import React, { useRef, useState } from "react";
import { MindMapFrame } from "./MindMapFrame";
import { MindMapHeader } from "./MindMapHeader";
import { MindMapCanvas } from "./MindMapCanvas";
import { MindMapModal } from "./MindMapModal";
import { useMindMapState } from "./hooks/useMindMapState";
import { useMindMapExport } from "./hooks/useMindMapExport";
import type { MindMapProps } from "./types";

export const MindMap: React.FC<MindMapProps> = ({
  title,
  data,
  description,
  initialCollapseLevel = 2,
}) => {
  const { expanded, toggle } = useMindMapState(data, 1);
  const [modalOpen, setModalOpen] = useState(false);
  const canvasRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = useMindMapExport(canvasRef, title);

  return (
    <>
      <MindMapFrame>
        <MindMapHeader
          title={title}
          mode="inline"
          onDownload={exportPNG}
          onToggleExpand={() => setModalOpen(true)}
        />
        <div className="bg-muted/20">
          <MindMapCanvas
            root={data}
            expanded={expanded}
            onToggle={toggle}
            canvasRef={canvasRef}
          />
        </div>
      </MindMapFrame>

      <MindMapModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title={title}
        root={data}
        expanded={expanded}
        onToggle={toggle}
      />
    </>
  );
};
